module.exports = __webpack_public_path__ + "img/icon-state-check.4c109bc4.svg";